import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Tombstone } from 'app/models/Tombstone';
import { CemeterySelectedService } from 'app/services/cemetery-selected.service';
import { FirebaseService } from 'app/services/firebase.service';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css'],
})
export class MapComponent implements OnInit {
  map: any;
  title = 'google maps test';
  lat = undefined;
  lng = undefined;
  tombstones: Array<Tombstone>;
  tombstonesFiltered: Array<Tombstone>;
  private selectedCemeteries: Array<string> = [];

  constructor(
    private tombstoneService: FirebaseService,
    private selectedCemeteriesService: CemeterySelectedService,
    private router: Router
  ) {

  }

  ngOnInit(): void { 

    this.getData();

  }

  getData() {
    this.tombstoneService.getTombstones().subscribe((res) => {
      this.tombstones = res as Array<Tombstone>;
      this.selectedCemeteriesService.selectedCemeteries$.subscribe((c) => {
        this.tombstonesFiltered = this.tombstones.filter(
          (t) => c.includes(t.cemetery) || c.length === 0
        );
        let i = 0;
        while (this.lat == undefined || this.lng == undefined) {
          let randomTombstone = this.tombstonesFiltered[
            Math.floor(Math.random() * this.tombstonesFiltered.length)
          ];

          if (localStorage.getItem('mapLatValue') == null || localStorage.getItem('mapLatValue') == '') {
            this.lat = (randomTombstone.lat || 52 as unknown) as number;
          }else{
            this.lat = +localStorage.getItem('mapLatValue') as number;
          }

          if (localStorage.getItem('mapLonValue') == null || localStorage.getItem('mapLonValue') == '') {
            this.lng = (randomTombstone.lon || 21 as unknown) as number;
          }else{
            this.lng = +localStorage.getItem('mapLonValue') as number;
          }

          if (localStorage.getItem('mapZoomValue') != null && localStorage.getItem('mapZoomValue') != '') {
            this.map.zoom = +localStorage.getItem('mapZoomValue');
          }

        }
        this.map.setCenter({ lat: this.lat, lng: this.lng });
      });
    });
  }


  mapReady(map) {
    this.map = map;
  }


  goToTombstone(t: Tombstone) {
    localStorage.setItem('mapLatValue', this.map.getCenter().lat());
    localStorage.setItem('mapLonValue', this.map.getCenter().lng());
    localStorage.setItem('mapZoomValue', this.map.getZoom());
    const id = t ? t.name : null;
    this.router.navigate(['details', id]);
  }
}
